import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Morning from "./single-mob-disk/All-Azkare-Disktop/Morning-Disktop";
import Evening from "./single-mob-disk/All-Azkare-Disktop/Evening-Disktop";
import GettingUp from "./single-mob-disk/All-Azkare-Disktop/GettingUp-Disktop";
import styles from "./../styles/azkar.module.css";
import { toast } from "react-toastify";
import EveningCount from "./Counts/Evening-Count";

import PopoverPopupState from "./Esnad/Details";
import GettingUpCount from "./Counts/GettingUp-Count";

// import sound from "./../sound/0225.mp3"

const morningAzkar = {
  hold: {
    text: `بسم ﷲ الرحمن الرحيم
{ قُل هُوَ اللَّهُ أَحَدٌ * اللَّهُ الصَّمَدُ * لَم يَلِد وَ لَم يُولَد *
  وَ لَم يَكُن لَّهُ كُفُواً أَحَدٌ }
- ( ثلاث مرات )`,
    count: 3,
    Details: `عن أبو داود واللفظ له، والترمذي وقال حسن صحيح غريب، والنسائي عن عبد الله بن خبيب رضي الله عنه قال: قال رسول الله صلى الله عليه وسلم: قل، قلت يا رسول الله ما أقول؟ قال: قل هو الله أحد، والمعوذتين حين تمسي وحين تصبح ثلاث مرات تكفيك من كل شيء`,
  },
  Falaq: {
    text: `بسم ﷲ الرحمن الرحيم
{ قُل أَعُوذُ بِرَبِّ الفَلَقِ * مِن شَرِّ مَا خَلَقَ *
  وَ مِن شَرِّ غَاسِقٍ إِذَا وَقَبَ * وَ مِن شَرِّ النَّفَّاثَاتِ فِي العُقَدِ *
  وَ مِن شَرِّ حَاسِدٍ إِذَا حَسَدَ }
- ( ثلاث مرات )`,
    count: 3,
    Details: `ورد هذا الأمر في ” سنن الترمذي ” حديث رقم: (3924) – حَدَّثَنَا عَبْدُ بْنُ حُمَيْدٍ ، قَالَ : حَدَّثَنَا مُحَمَّدُ بْنُ إِسْمَاعِيلَ بْنِ أَبِي فُدَيْكٍ ، قَالَ : حَدَّثَنَا ابْنُ أَبِي ذِئْبٍ ، عَنْ أَبِي سَعِيدٍ البَرَّادِ ، عَنْ مُعَاذِ بْنِ عَبْدِ اللهِ بْنِ خُبَيْبٍ ، عَنْ أَبِيهِ ، قَالَ : خَرَجْنَا فِي لَيْلَةٍ مَطِيرَةٍ وَظُلْمَةٍ شَدِيدَةٍ نَطْلُبُ رَسُولَ اللهِ صَلَّى اللَّهُ عَلَيْهِ وَسَلَّمَ يُصَلِّي لَنَا ، قَالَ : فَأَدْرَكْتُهُ ، فَقَالَ : قُلْ فَلَمْ أَقُلْ شَيْئًا ، ثُمَّ قَالَ : قُلْ ، فَلَمْ أَقُلْ شَيْئًا ، قَالَ : قُلْ ، فَقُلْتُ ، مَا أَقُولُ ؟ قَالَ : قُلْ : قُلْ هُوَ اللَّهُ أَحَدٌ ، وَالمُعَوِّذَتَيْنِ حِينَ تُمْسِي وَتُصْبِحُ ثَلاَثَ مَرَّاتٍ تَكْفِيكَ مِنْ كُلِّ شَيْءٍ.`,
  },
  people: {
    text: `بسم ﷲ الرحمن الرحيم
{ قُل أَعُوذُ بِرَبِّ النَّاسِ * مَلِكِ النَّاسِ * إِلَهِ النَّاسِ *
  مِن شَرِّ الوَسوَاسِ الخَنَّاسِ *
  الَّذِي يُوَسوِسُ فِي صُدُورِ النَّاسِ * مِنَ الجِنَّةِ وَ النَّاسِ }
- ( ثلاث مرات )

- من قالهم ثلاث مرات حين يصبح
  و حـيـن يمسي كفته من كل شيء  `,
    count: 3,
    Details: `فعن عبد الله بن خبيب -رضي الله عنه- عن النبيّ -صلّى الله عليه وسلّم- قال: (خرجنا في ليلةِ مَطَرٍ وظُلْمَةٍ شديدةٍ نطلبُ رسولَ اللهِ صلى الله عليه وسلم لِيُصليَ لنا، فأدركناه، فقال: أصليتم؟ فلم أقلْ شيئًا، فقال: قلْ. فلم أقلْ شيئًا، ثم قال: قلْ. فلم أقلْ شيئًا، ثم قال: قلْ: فقلتُ: يا رسولَ اللهِ، ما أقولُ؟ قال: قل هو الله أحد والمُعَوِّذَتين حينَ تُمسي وحينَ تُصبحُ ثلاثَ مراتٍ تُكفيك مِن كلِّ شيءٍ)`,
  },
  // this is 2
  become: {
    text: `( اللـهــمَّ بـك أصـبـحـنــا ، و بـك أمـسـيـنــا ،
  و بـك نحيا ، و بـك نموت ، و إليك النشور )
- ( حسن )`,
    count: 1,
    Details: `جاء من حديث أبي هريرة  قال: كان رسولُ الله ﷺ يُعلِّم أصحابَه يقول: إذا أصبح أحدُكم فليقل: اللهم بك أصبحنا، وبك أمسينا، وبك نحيا، وبك نموت، وإليك المصير،  نموت، وإليك النُّشور`,
  },
  unseen: {
    text: `( اللهمَّ عالم الغيب و الشهادة ، فاطر السموات و الأرض ،
  رب كــل شـيء و مـلـيـكــه ، أشــهـــد أن لا إله إلا أنت ،
  أعـوذ بك مـن شـر نفسي ، و مـن شـر الشيطان و شركه وأن أقترف على نفسي سوءا أو أجره إلى مسلم  )
- ( صحيح )`,
    count: 1,
    Details: `جاء عن أبي هريرة  قال: قال أبو بكر : يا رسول الله، مُرني بشيءٍ أقوله إذا أصبحتُ، وإذا أمسيتُ. قال: قل: اللهم عالم الغيب والشَّهادة، فاطر السَّماوات والأرض، ربَّ كل شيءٍ ومليكه، أشهد أن لا إله إلا أنت، أعوذ بك من شرِّ نفسي، ومن شرِّ الشيطانِ وشِرْكِه، قال: قُلْه إذا أصبحتَ، وإذا أمسيتَ، وإذا أخذتَ مضجعك`,
  },
  Glory: {
    text: `( سـبـحـان ﷲ و بـحـمـده ، عـدد خـلـقــه ،
  و رضا نفسه و زنة عرشه ، و مداد كلماته )
- ثلاث مرات ( صحيح )`,
    count: 3,
    Details: `روى مسلم (2726) عَنِ ابْنِ عَبَّاسٍ عَنْ جُوَيْرِيَةَ رضي الله عنها : " أَنَّ النَّبِيَّ صَلَّى اللهُ عَلَيْهِ وَسَلَّمَ خَرَجَ مِنْ عِنْدِهَا بُكْرَةً حِينَ صَلَّى الصُّبْحَ ، وَهِيَ فِي مَسْجِدِهَا، ثُمَّ رَجَعَ بَعْدَ أَنْ أَضْحَى ، وَهِيَ جَالِسَةٌ ، فَقَالَ: (مَا زِلْتِ عَلَى الْحَالِ الَّتِي فَارَقْتُكِ عَلَيْهَا؟) قَالَتْ: نَعَمْ ، قَالَ النَّبِيُّ صَلَّى اللهُ عَلَيْهِ وَسَلَّمَ: ( لَقَدْ قُلْتُ بَعْدَكِ أَرْبَعَ كَلِمَاتٍ ، ثَلَاثَ مَرَّاتٍ ، لَوْ وُزِنَتْ بِمَا قُلْتِ مُنْذُ الْيَوْمِ لَوَزَنَتْهُنَّ: سُبْحَانَ اللهِ وَبِحَمْدِهِ، عَدَدَ خَلْقِهِ وَرِضَا نَفْسِهِ وَزِنَةَ عَرْشِهِ وَمِدَادَ كَلِمَاتِهِ ) .
قال القاري رحمه الله :
" ( لَوَزَنَتْهُنَّ) أَيْ : لَتَرَجَّحَتْ تِلْكَ الْكَلِمَاتُ عَلَى جَمِيعِ أَذْكَارِكِ ، وَزَادَتْ عَلَيْهِنَّ فِي الْأَجْرِ وَالثَّوَابِ ، أَوْ لَسَاوَتْهُنَّ، أَيْ: سَاوَتْهُنَّ ، أَوْ غَلَبَتْهُنَّ، وَفِيهِ تَنْبِيهٌ عَلَى أَنَّهَا كَلِمَاتٌ كَثِيرَةُ الْمَعْنَى ؛ لَوْ قُوبِلَتْ بِمَا قُلْتِ لَسَاوَتْهُنَّ "`,
  },
  // this is 3
  Primitiveness: {
    text: `( أصبحنا علي فطرة الإسلام ، و على كلمة إلاخلاص ،
 و على ديـــن نـبـيـنـــا مـحـمـــد ﷺ ،
 و على ملة أبينا إبراهيم حنيفاً مسلماً
 و مــا كــان مــن الـمـشــركـيــن )
- ( سنده صحيح )`,
    count: 1,
    Details: `جاء عن عبدالله بن عبدالرحمن بن أبزى، عن أبيه -رضي الله عنهما- قال: كان النبيُّ ﷺ إذا أصبح قال: أصبحنا على فطرة الإسلام، وكلمة الإخلاص، ودين نبينا محمدٍ ﷺ، وملّة أبينا إبراهيم حنيفًا مسلمًا، وفي روايةٍ: وعلى دين نبينا محمدٍ، وعلى ملَّة أبينا، وفي آخره: وما كان من المشركين، وفي روايةٍ: أصبحنا على الفطرة والإخلاص، ودين نبينا محمدٍ، وملَّة أبينا إبراهيم حنيفًا مسلمًا، وما أنا من المشركين`,
  },
  pardon: {
    text: `(  اللهمَّ إني أسألك العفو و العافية في الدنيا و الآخـرة ،
   اللهم إني أسألك العفو و العافية في دينـي و دنـيـاي ،
   و أهلي و مالي ، اللهم استر عوراتي ، و آمن روعاتي ،
   اللهم احفظني من بين يدي و من خلفي ،
   و عن يميني و عن شمالي ، و من فوقي ،
   و أعوذ بـعـظـمـتـك أن أغتال من تحتي )
- ( سنده صحيح )`,
    count: 1,
    Details: `جاء عن عبدالله بن عمر  أنَّه قال: لم يكن رسولُ الله ﷺ يدع هؤلاء الدَّعوات حين يُمسي وحين يُصبح: اللهم إني أسألك العافيةَ في الدنيا والآخرة، اللهم إني أسألك العفو والعافية في ديني ودُنياي وأهلي ومالي، اللهم استر عوراتي، وآمن روعاتي، اللهم احفظني من بين يدي، ومن خلفي، وعن يميني، وعن شمالي، ومن فوقي، وأعوذ بعظمتك أن أُغتال من تحتي`,
  },
  HeHasNoPartner: {
    text: `
( لا إله إلا ﷲ وحــده لا شــريــك له ،
  له الملك و له الحمد يحيي و يميت ،
  و هــو عـلـى كـــل شـــيء قــديـــر )
- عشر مرات ( حسن )`,
    count: 10,
    Details: `جاء من حديث أبي ذرٍّ: أنَّ رسولَ الله ﷺ قال: مَن قال في دُبر صلاة الفجر وهو ثانٍ رجليه، قبل أن يتكلم: لا إله إلا الله وحده لا شريكَ له، له الملك، وله الحمد، يُحيي ويُميت، وهو على كل شيءٍ قدير. عشر مرات؛ كُتِبَ له عشر حسناتٍ، ومُحِيَ عنه عشر سيئاتٍ، ورُفِعَ له عشر درجاتٍ، وكان يومه ذلك كلّه في حرزٍ من كل مكروهٍ، وحُرِسَ من الشَّيطان، ولم ينبغِ لذنبٍ أن يُدركه في ذلك اليوم، إلا الشِّرك بالله. هذا الحديث أخرجه الترمذي، وقال عنه: حسنٌ، غريبٌ، صحيحٌ`,
  },
  // this is 4 => 5 zekr
  HisName: {
    text: `( بـســم ﷲ الــذي لا يـضــر مـع اسـمـــه شــيء
  في الأرض و لا في السماء و هو السميع العليم )
- ثلاث مرات ( حسن لغيره )`,
    count: 3,
    Details: `عن عثمان بن عفان رضي الله عنه قال: قال النبي عليه الصلاة والسلام: (ما من عبد يقول في صباح كل يوم ومساء كل ليلة: باسم الله الذي لا يضر مع اسمه شيء في الأرض ولا في السماء وهو السميع العليم، ثلاث مرات لم يضره شيء)

وقال: (ما نزل أحدكم منزلاً -أي: يخشى منه- فيقول: باسم الله الذي لا يضر مع اسمه شيء في الأرض ولا في السماء وهو السميع العليم ثلاث مرات لم يضره شيء حتى يخرج) أي: حتى يخرج من هذا الذي يخافه، فلم يضره شيء حتى يصبح أو حتى يمسي`,
  },
  AskForgiveness: {
    text: `دعاء سيد الإستغفار
( اللهم أنت ربي لا إله إلا أنت خلقتني و أنـا عـبـدك ،
  و أنـا عـلـى عــهـــدك و وعـــدك مــا اسـتـطـعـــت ،
  أعوذ بك من شر ما صنعت ، أبوء لك بنعمتك علي ،
  و أبوء بذنبي فاغفر لي فإنه لا يغفر الذنوب إلا أنت )
- ( صحيح البخاري )`,
    count: 1,
    Details: `حديث صحيح رواه البخاري في صحيحه من حديث شداد بن أوس، يقول -عليه الصلاة والسلام-: سيد الاستغفار أن تقول: اللهم أنت ربي لا إله إلا أنت، خلقتني وأنا عبدك ... إلى آخره، فهو حديث صحيح`,
  },
  GlorybetoHim: {
    text: `( سـبـحـان ﷲ و بـحـمـده )
- مائة مرة`,
    count: 100,
    Details: `عن النبي صَلَّى اللَّهُ عَلَيْهِ وَسَلَّمَ أنه قال : ( مَنْ قَالَ حِينَ يُصْبِحُ وَحِينَ يُمْسِي : سُبْحَانَ اللَّهِ وَبِحَمْدِهِ مِائَةَ مَرَّةٍ ، لَمْ يَأْتِ أَحَدٌ يَوْمَ الْقِيَامَةِ بِأَفْضَلَ مِمَّا جَاءَ بِهِ إِلَّا أَحَدٌ قَالَ مِثْلَ مَا قَالَ أَوْ زَادَ عَلَيْهِ ) أخرجه مسلم (2692)`,
  },
  charm: {
    text: `( أعوذ بكلمات ﷲ التامات من شر ما خلق )
- ثلاث مرات`,
    count: 3,
    Details: `من قالَ حين يصبحُ أعوذُ بكلماتِ الله التاماتِ من شرِّ ما خلقَ ثلاثَ مراتٍ لم تضرهُ عقربٌ حتى يمسِي ، ومن قالها حينَ يمسي لم تضرُّه حتى يصبحَ
الراوي : أبو هريرة | المحدث : ابن حجر العسقلاني | المصدر : نتائج الأفكار | الصفحة أو الرقم : 2/360 | خلاصة حكم المحدث : له أصل | التخريج : أخرجه مسلم (2709) بنحوه`,
  },
  Wehavebecome: {
    text: `(( أَصـبَـحـنَـا وَ أَصـبَـحَ الـمُـــلكُ لِلَّهِ ،
  وَ الحَـمـدُ لِلَّهِ لَا إِلَهَ إِلَّا اللهُ ، وَحدَهُ لَا شَرِيكَ لَهُ ،
  لَهُ المُلكُ وَ لَهُ الحَمدُ وَ هُـوَ عَلَى كُلِّ شَيءٍ قَدِيرٌ ،
  رَبِّ أَســأَلُـكَ خَـيـرَ مَا فِي هَذِا اليوم وَ خَيرَ مَا بَعدَهَ ،
  وَ أَعُوذُ بِكَ مِن شَرِّ مَا فِي هَذِا اليوم وَ شَــرِّ مَا بَعدَهَ ،
  رَبِّ أَعُوذُ بِكَ مِنَ الكَسَلِ وَ سُوءِ الكِبَرِ ،
  رَبِّ أَعُوذُ بِكَ مِن عَذَابٍ فِي النَّارِ وَ عَذَابٍ فِي القَبرِ ))`,
    count: 1,
    Details: `جاء من أذكار المساء والصباح: ما رواه الإمامُ مسلم -رحمه الله- في "صحيحه" من حديث عبدالله بن مسعودٍ  قال: "كان نبيُّ الله ﷺ إذا أمسى قال: أمسينا وأمسى الملكُ لله، والحمد لله، لا إله إلا الله وحده لا شريكَ له، له الملك، وله الحمد، وهو على كل شيءٍ قدير، ربِّ أسألك خيرَ ما في هذه الليلة، وخيرَ ما بعدها، وأعوذ بك من شرِّ ما في هذه الليلة، وشرِّ ما بعدها، ربِّ أعوذ بك من الكسل، وسُوء الكِبَر، ربِّ أعوذ بك من عذابٍ في النار، وعذابٍ في القبر، وإذا أصبح قال أيضًا: أصبحنا وأصبح الملك لله ...، إلى آخره`,
  },
};

function ContentAzkar() {
  // const aduio = new Audio();
  // aduio.src = sound;

  const { pathname } = useLocation();

  // this is 1
  const [count1, setCount1] = useState(3);
  const [count2, setCount2] = useState(3);
  const [count3, setCount3] = useState(3);

  // this is 2
  const [count4, setCount4] = useState(1);
  const [count5, setCount5] = useState(1);
  const [count6, setCount6] = useState(3);

  // this is 3
  const [count7, setCount7] = useState(1);
  const [count8, setCount8] = useState(1);
  const [count9, setCount9] = useState(10);

  // last 5 states
  const [count10, setCount10] = useState(3);
  const [count11, setCount11] = useState(1);
  const [count12, setCount12] = useState(100);
  const [count13, setCount13] = useState(3);
  const [count14, setCount14] = useState(1);

  const [countDone, setCountDone] = useState(false);

  let navigate = useNavigate();

  const done1 = () => {
    count1 > 0 && setCount1(count1 - 1);
  };

  const done2 = () => {
    count2 > 0 && setCount2(count2 - 1);
    // if (!countDone) {
    //   if (count2 === 1) {
    //     setCountDone(true);
    //     toast.success("🦄 Wow so easy!", {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //   }
    // }
  };

  const done3 = () => {
    count3 > 0 && setCount3(count3 - 1);
    // if (!countDone) {
    //   if (count3 === 1) {
    //     setCountDone(true);
    //     toast.success("🦄 Wow so easy!", {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //   }
    // }
  };

  const done4 = () => {
    count4 > 0 && setCount4(count4 - 1);
    // if (!countDone) {
    //   if (count3 === 1) {
    //     setCountDone(true);
    //     toast.success("🦄 Wow so easy!", {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //   }
    // }
  };

  const done5 = () => {
    count5 > 0 && setCount5(count5 - 1);
    // if (!countDone) {
    //   if (count3 === 1) {
    //     setCountDone(true);
    //     toast.success("🦄 Wow so easy!", {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //   }
    // }
  };

  const done6 = () => {
    count6 > 0 && setCount6(count6 - 1);
    // if (!countDone) {
    //   if (count3 === 1) {
    //     setCountDone(true);
    //     toast.success("🦄 Wow so easy!", {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //   }
    // }
  };

  const done7 = () => {
    count7 > 0 && setCount7(count7 - 1);
    // if (!countDone) {
    //   if (count3 === 1) {
    //     setCountDone(true);
    //     toast.success("🦄 Wow so easy!", {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //   }
    // }
  };

  const done8 = () => {
    count8 > 0 && setCount8(count8 - 1);
    // if (!countDone) {
    //   if (count3 === 1) {
    //     setCountDone(true);
    //     toast.success("🦄 Wow so easy!", {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //   }
    // }
  };

  const done9 = () => {
    count9 > 0 && setCount9(count9 - 1);
    // if (!countDone) {
    //   if (count3 === 1) {
    //     setCountDone(true);
    //     toast.success("🦄 Wow so easy!", {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //   }
    // }
  };

  // Last 5 zekr
  const done10 = () => {
    count10 > 0 && setCount10(count10 - 1);
    // if (!countDone) {
    //   if (count3 === 1) {
    //     setCountDone(true);
    //     toast.success("🦄 Wow so easy!", {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //   }
    // }
  };

  const done11 = () => {
    count11 > 0 && setCount11(count11 - 1);
    // if (!countDone) {
    //   if (count3 === 1) {
    //     setCountDone(true);
    //     toast.success("🦄 Wow so easy!", {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //   }
    // }
  };

  const done12 = () => {
    count12 > 0 && setCount12(count12 - 1);
    // if (!countDone) {
    //   if (count3 === 1) {
    //     setCountDone(true);
    //     toast.success("🦄 Wow so easy!", {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //   }
    // }
  };

  const done13 = () => {
    count13 > 0 && setCount13(count13 - 1);
    // if (!countDone) {
    //   if (count3 === 1) {
    //     setCountDone(true);
    //     toast.success("🦄 Wow so easy!", {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //   }
    // }
  };

  const done14 = () => {
    count14 > 0 && setCount14(count14 - 1);
    if (!countDone) {
      if (count14 === 1) {
        setCountDone(true);
        toast.success(
          "لقد اتممت اذكار الصباح , فتح الله عليك و تقبل منك صالح الاعمال♥",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );
        navigate("/");
      }
    }
  };

  // Chack Text
  const azkarNow = () => {
    if (count1 >= 1) {
      return morningAzkar.hold.text;
    } else if (count1 <= 1 && count2 >= 1) {
      return morningAzkar.Falaq.text;
    } else if (count2 <= 1 && count3 >= 1) {
      return morningAzkar.people.text;
    } else if (count3 <= 1 && count4 >= 1) {
      return morningAzkar.become.text;
    } else if (count4 <= 1 && count5 >= 1) {
      return morningAzkar.unseen.text;
    } else if (count5 <= 1 && count6 >= 1) {
      return morningAzkar.Glory.text;
    } else if (count6 <= 1 && count7 >= 1) {
      return morningAzkar.Primitiveness.text;
    } else if (count7 <= 1 && count8 >= 1) {
      return morningAzkar.pardon.text;
    } else if (count8 <= 1 && count9 >= 1) {
      return morningAzkar.HeHasNoPartner.text; // this is line
    } else if (count9 <= 1 && count10 >= 1) {
      return morningAzkar.HisName.text;
    } else if (count10 <= 1 && count11 >= 1) {
      return morningAzkar.AskForgiveness.text;
    } else if (count11 <= 1 && count12 >= 1) {
      return morningAzkar.GlorybetoHim.text;
    } else if (count12 <= 1 && count13 >= 1) {
      return morningAzkar.charm.text;
    } else if (count13 <= 1 && count14 >= 1) {
      return morningAzkar.Wehavebecome.text;
    } else {
      return `لقد اتممت اذكار الصباح لا تنسي اذكار المساء ♥♥♥`;
    }
  };

  // Chack Text
  const DetailsAzkarNow = () => {
    if (count1 >= 1) {
      return morningAzkar.hold.Details;
    } else if (count1 <= 1 && count2 >= 1) {
      return morningAzkar.Falaq.Details;
    } else if (count2 <= 1 && count3 >= 1) {
      return morningAzkar.people.Details;
    } else if (count3 <= 1 && count4 >= 1) {
      return morningAzkar.become.Details;
    } else if (count4 <= 1 && count5 >= 1) {
      return morningAzkar.unseen.Details;
    } else if (count5 <= 1 && count6 >= 1) {
      return morningAzkar.Glory.Details;
    } else if (count6 <= 1 && count7 >= 1) {
      return morningAzkar.Primitiveness.Details;
    } else if (count7 <= 1 && count8 >= 1) {
      return morningAzkar.pardon.Details;
    } else if (count8 <= 1 && count9 >= 1) {
      return morningAzkar.HeHasNoPartner.Details; // this is line
    } else if (count9 <= 1 && count10 >= 1) {
      return morningAzkar.HisName.Details;
    } else if (count10 <= 1 && count11 >= 1) {
      return morningAzkar.AskForgiveness.Details;
    } else if (count11 <= 1 && count12 >= 1) {
      return morningAzkar.GlorybetoHim.Details;
    } else if (count12 <= 1 && count13 >= 1) {
      return morningAzkar.charm.Details;
    } else if (count13 <= 1 && count14 >= 1) {
      return morningAzkar.Wehavebecome.Details;
    } else {
      return `لقد اتممت اذكار الصباح لا تنسي اذكار المساء ♥♥♥`;
    }
  };

  // Chack Action
  const actionNow = () => {
    if (count1 >= 1) {
      return (
        <div className={`col-md-4  col-lg-3 flex justify-center `}>
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
            onClick={done1}
            >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count1 >= 0 && `${morningAzkar.hold.count} / ${count1}`}
            </div>
          </button>
        </div>
      );
    } else if (count1 <= 1 && count2 >= 1) {
      return (
        <div className={`col-md-4  col-lg-3  flex justify-center `}>
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
            onClick={done2}
            >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count2 >= 0 && `${morningAzkar.Falaq.count} / ${count2}`}
            </div>
          </button>
        </div>
      );
    } else if (count2 <= 1 && count3 >= 1) {
      return (
        <div className={`col-md-4  col-lg-3  flex justify-center `}>
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
            onClick={done3}
            >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count3 >= 0 && `${morningAzkar.people.count} / ${count3}`}
            </div>
          </button>
        </div>
      );
    } else if (count3 <= 1 && count4 >= 1) {
      return (
        <div className={`col-md-4  col-lg-3  flex justify-center `}>
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
            onClick={done4}
            >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count4 >= 0 && `${morningAzkar.become.count} / ${count4}`}
            </div>
          </button>
        </div>
      );
    } else if (count4 <= 1 && count5 >= 1) {
      return (
        <div className={`col-md-4  col-lg-3  flex justify-center `}>
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
            onClick={done5}
            >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count5 >= 0 && `${morningAzkar.unseen.count} / ${count5}`}
            </div>
          </button>
        </div>
      );
    } else if (count5 <= 1 && count6 >= 1) {
      return (
        <div className={`col-md-4  col-lg-3  flex justify-center `}>
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
            onClick={done6}
            >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count6 >= 0 && `${morningAzkar.Glory.count} / ${count6}`}
            </div>
          </button>
        </div>
      );
    } else if (count6 <= 1 && count7 >= 1) {
      return (
        <div className={`col-md-4  col-lg-3  flex justify-center `}>
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
            onClick={done7}
            >
            <h6>انقر هنا</h6>
            <div>
              {count7 >= 0 && `${morningAzkar.Primitiveness.count} / ${count7}`}
            </div>
          </button>
        </div>
      );
    } else if (count7 <= 1 && count8 >= 1) {
      return (
        <div className={`col-md-4  col-lg-3  flex justify-center `}>
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
            onClick={done8}
            >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count8 >= 0 && `${morningAzkar.pardon.count} / ${count8}`}
            </div>
          </button>
        </div>
      );
    } else if (count8 <= 1 && count9 >= 1) {
      return (
        <div className={`col-md-4  col-lg-3  flex justify-center `}>
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
            onClick={done9}
            >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count9 >= 0 &&
                `${morningAzkar.HeHasNoPartner.count} / ${count9}`}
            </div>
          </button>
        </div>
      );
    } else if (count9 <= 1 && count10 >= 1) {
      return (
        <div className={`col-md-4  col-lg-3  flex justify-center `}>
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
            onClick={done10}
            >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count10 >= 0 && `${morningAzkar.HisName.count} / ${count10}`}
            </div>
          </button>
        </div>
      );
    } else if (count10 <= 1 && count11 >= 1) {
      return (
        <div className={`col-md-4  col-lg-3  flex justify-center `}>
          <button
            onClick={done11}
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
          >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count11 >= 0 &&
                `${morningAzkar.AskForgiveness.count} / ${count11}`}
            </div>
          </button>
        </div>
      );
    } else if (count11 <= 1 && count12 >= 1) {
      return (
        <div className={`col-md-4  col-lg-3  flex justify-center `}>
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
            onClick={done12}
            >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count12 >= 0 &&
                `${morningAzkar.GlorybetoHim.count} / ${count12}`}
            </div>
          </button>
        </div>
      );
    } else if (count12 <= 1 && count13 >= 1) {
      return (
        <div className={`col-md-4  col-lg-3  flex justify-center `}>
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
            onClick={done13}
            >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count13 >= 0 && `${morningAzkar.charm.count} / ${count13}`}
            </div>
          </button>
        </div>
      );
    } else if (count13 <= 1 && count14 >= 1) {
      return (
        <div className={`col-md-4  col-lg-3  flex justify-center `}>
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
            onClick={done14}
            >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count14 >= 0 &&
                `${morningAzkar.Wehavebecome.count} / ${count14}`}
            </div>
          </button>
        </div>
      );
    } else {
      return null;
    }
  };

  /* Morning */
  if (pathname === "/morning") {
    return (
      <div className="relative ">
        <Morning />
        {/*  */}
        <div className="flex justify-end mt-5 container">
          <div className="flex  z-40 justify-between mx-2 align-items-center row gap-4">
            <div className={`col-md-4 col-lg-8 px-2  py-2 ${styles.leftAzkar}`}>
              <h5 className="mb-0">{azkarNow()}</h5>
              <div className="text-start px-4">
                <PopoverPopupState text={DetailsAzkarNow()} />
              </div>
            </div>
            {actionNow()}
          </div>
        </div>
      </div>
    );
    /* evening */
  } else if (pathname === "/evening") {
    return (
      <>
        <Evening />
        <EveningCount />
      </>
    );
    /* gettingUp */
  } else if (pathname === "/gettingUp") {
    return (
      <>
        <GettingUp />
        <GettingUpCount />
      </>
    );
  } else {
    return <h1>this is page is nout Found</h1>;
  }
}

export default ContentAzkar;
